exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".beneficios-inicio__beneficio{-ms-flex-align:start;align-items:flex-start;display:-ms-flexbox;display:flex;padding-bottom:16px;padding-top:16px}.beneficios-inicio__beneficio__icono{-ms-flex:0 0 48px;flex:0 0 48px;height:48px;width:48px}.beneficios-inicio__beneficio__icono>img{height:100%;width:100%}.beneficios-inicio__beneficio__contenido{margin-left:8px}.beneficios-inicio__beneficio__titulo{font-family:BentonSansBBVA Medium;font-size:16px;line-height:24px}.beneficios-inicio__beneficio__texto{font-size:15px;list-style:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null]}!./src/css/components/BannerInicio/Beneficio.css
// module id = 709
// module chunks = 8